import { browser } from './browser-capabilities';
import { isDefined } from './isDefined';

export const isDesktopSharingAvailable = () => {
    return Boolean(navigator.mediaDevices?.getDisplayMedia);
};

let isAudioOutputDeviceChangeAvailable: Maybe<boolean>;

const checkIsAudioOutputDeviceChangeAvailable = () => {
    if (isDefined(isAudioOutputDeviceChangeAvailable)) {
        return isAudioOutputDeviceChangeAvailable;
    }

    isAudioOutputDeviceChangeAvailable = typeof document.createElement('audio').setSinkId !== 'undefined';

    return isAudioOutputDeviceChangeAvailable;
};

export const isDeviceChangeAvailable = (deviceType: 'input' | 'output' | 'audiooutput'): boolean => {
    return deviceType === 'output' || deviceType === 'audiooutput' ? checkIsAudioOutputDeviceChangeAvailable() : true;
};

export const isDeviceListAvailable = () => {
    return Boolean(navigator.mediaDevices?.enumerateDevices);
};
export const isAlwaysDefaultOutput = () => {
    return (!isDeviceChangeAvailable('output') && browser()?.isSafariBased()) ?? false;
};

export const isForceDefaultOutput = (countOutputDevices: number) => {
    return Boolean(browser()?.isSafariBased()) && (isAlwaysDefaultOutput() || countOutputDevices === 0);
};
